import {
  getLocalItemTtl,
  purgeExpiredLocalStorage,
  removeLocalItem,
  setLocalItemTtl,
} from './localStorageTtl';
import {
  getSessionItemTtl,
  purgeExpiredSessionStorage,
  removeSessionItem,
  setSessionItemTtl,
} from './sessionStorageTtl';

export const getLocalItem = (key) => getLocalItemTtl(key);
export const setLocalItem = (key, value) => setLocalItemTtl(key, value);
export const deleteLocalItem = (key) => removeLocalItem(key);
export const purgeExpiredLocal = () => purgeExpiredLocalStorage();

export const getSessionItem = (key) => getSessionItemTtl(key);
export const setSessionItem = (key, value) => setSessionItemTtl(key, value);
export const deleteSessionItem = (key) => removeSessionItem(key);
export const purgeExpiredSession = () => purgeExpiredSessionStorage();

